import React, { Component } from "react";
import { render } from "react-dom";
import { LocalizationService } from "@progress/kendo-react-intl";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Button } from "@progress/kendo-react-buttons";
import { Zvuky } from "../Zvuky";
import cookie from "react-cookies";
import moment from "moment";

let resolve;

class TestZvukovDialog extends Component {
    static create(props = {}) {
        const containerElement = document.createElement("div");
        document.body.appendChild(containerElement);
        return render(<TestZvukovDialog createProps={props} />, containerElement);
    }

    constructor() {
        super();

        this.state = {
            isOpen: false,
            played: false,
            showProps: {}
        };

        this.handleCancel = this.handleCancel.bind(this);
        this.handlePrehratZvuky = this.handlePrehratZvuky.bind(this);
        this.handleZvukySuOk = this.handleZvukySuOk.bind(this);
        this.show = this.show.bind(this);
    }

    handlePrehratZvuky = () => {
        Zvuky.playOk();
        Zvuky.playPozor();
        this.setState({ played: true });

        var tommorow = moment().startOf("date").add(1, 'day').add(2, 'hour').toDate();
        var maxAge = (tommorow - new Date()) / 1000;
        cookie.save("gPrebeholTestZvukov", true, { path: "/", expires: tommorow, maxAge: maxAge });
    };

    handleCancel() {
        this.setState({ isOpen: false });
        resolve(false);
    }

    handleZvukySuOk = () => {
        this.setState({ isOpen: false });
        resolve(true);
    };

    show(props = {}) {
        const showProps = { ...this.props.createProps, ...props };
        this.setState({ isOpen: true, showProps });
        return new Promise(res => {
            resolve = res;
        });
    }

    render() {
        var selectedLanguage = localStorage.getItem("selectedLanguage");
        var localizationService = new LocalizationService(selectedLanguage);

        const defaultProps = {
            title: localizationService.toLanguageString("TestZvukov.Test zvukov", "Test zvukov")
        };

        const { isOpen, showProps } = this.state;
        const { title, ...rest } = showProps;

        return isOpen ? (
            <Dialog title={title || defaultProps.title} onClose={this.handleCancel} width="600px">
                <div id="TestZvukovMessage" className="alert alert-info">
                    <p>
                        {localizationService.toLanguageString(
                            "TestZvukov.Pri skenovaní tovaru je dôležité zreteľné počutie zvuku z reproduktorov, ktorý signalizuje či skenovaný kus je v poriadku, alebo nastala nejaká chyba.",
                            "Pri skenovaní tovaru je dôležité zreteľné počutie zvuku z reproduktorov, ktorý signalizuje či skenovaný kus je v poriadku, alebo nastala nejaká chyba."
                        )}
                    </p>
                    <p>
                        {localizationService.toLanguageString(
                            "TestZvukov.Pomocou tlačítka Prehrať zvuky otestujte, či je úroveň hlasitosti reproduktorov nastavená správne, prípadne ju upravte.",
                            "Pomocou tlačítka Prehrať zvuky otestujte, či je úroveň hlasitosti reproduktorov nastavená správne, prípadne ju upravte."
                        )}
                    </p>
                    <p>
                        {localizationService.toLanguageString(
                            "TestZvukov.Ak nepočujete zvuky alebo neviete ako upraviť hlasitosť, kontaktujte technickú podporu.",
                            "Ak nepočujete zvuky alebo neviete ako upraviť hlasitosť, kontaktujte technickú podporu."
                        )}
                    </p>
                </div>
                <div>
                    <div className="col-xs-6 text-center">
                        <Button icon="volume-up" className="font-bold auto-focus" onClick={this.handlePrehratZvuky}>
                            {localizationService.toLanguageString("TestZvukov.Prehrať zvuky", "Prehrať zvuky")}
                        </Button>
                    </div>
                    <div className="col-xs-6 text-center">
                        <Button icon="check" className="font-bold" disabled={this.state.played == false} onClick={this.handleZvukySuOk}>
                            {localizationService.toLanguageString("TestZvukov.Zvuky sú OK", "Zvuky sú OK")}
                        </Button>
                    </div>
                </div>
            </Dialog>
        ) : (
            <React.Fragment />
        );
    }
}

export default TestZvukovDialog;



// WEBPACK FOOTER //
// ./src/components/common/testZvukovService/TestZvukovDialog.js